import { merchantInfoService } from "services";

import { merchantInfoConstants } from "./merchantInfo.constants";

export const merchantInfoActions = {
	getMerchantInformation,
	resetMerchantState,
	setMerchantHighRisk,
};

function resetMerchantState() {
	return {
		type: merchantInfoConstants.RESET_UNDERWRITING_MERCHANT_INFO_STATE,
	};
}

function getMerchantInformation(applicationId, tab) {
	return dispatch => {
		dispatch(request());

		return merchantInfoService
			.getMerchantInformation(applicationId, tab)
			.then(
				result => {
					dispatch(success(result));
					return Promise.resolve(result);
				},
				error => {
					dispatch(failure(error));
					return Promise.reject(error);
				},
			);
	};

	function request() {
		return {
			type: merchantInfoConstants.GET_UNDERWRITING_MERCHANT_INFO_REQUEST,
		};
	}
	function success(merchantInfo) {
		return {
			type: merchantInfoConstants.GET_UNDERWRITING_MERCHANT_INFO_SUCCESS,
			merchantInfo,
		};
	}
	function failure(error) {
		return {
			type: merchantInfoConstants.GET_UNDERWRITING_MERCHANT_INFO_ERROR,
			error,
		};
	}
}

function setMerchantHighRisk(isHighRisk) {
	return {
		type: merchantInfoConstants.SET_MERCHANT_INFO_HIGH_RISK,
		isHighRisk,
	};
}
